import { Component, forwardRef, HostBinding, OnDestroy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CheckboxComponentDef } from '@df/ui/form/checkbox/checkbox.component.def';

@Component({
    selector: 'checkbox',
    templateUrl: './checkbox.html',
    standalone: true,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CheckboxComponent),
            multi: true
        }
    ]
})
export class CheckboxComponent extends CheckboxComponentDef implements ControlValueAccessor, OnDestroy {
    @HostBinding('class.checkbox')
    getBaseClass = true;

    @HostBinding('class.is-checked')
    get getIsChecked() {
        return this.checked;
    }

    @HostBinding('class.is-disabled')
    get getIsDisabled() {
        return this.disabled;
    }
}
